// payBasis.js (Service File)
import axiosInstance from "../Axios";

export const PAY_BASIS_OPTIONS = [
  { label: "Monthly", value: "MONTHLY" },
  { label: "Daily", value: "DAILY" },
  { label: "Weekly", value: "WEEKLY" },
  { label: "Bi-weekly", value: "BIWEEKLY" },
  { label: "Hourly", value: "HOURLY" },
];

function getPayBasisList(pageNo = 1, params) {
  try {
    const queryParams = { pageNo };
    if (params && Object.keys(params).length > 0) {
      Object.assign(queryParams, params);
    }
    return axiosInstance.get("/payroll/pay-basis", { params: queryParams });
  } catch (error) {
    console.log("Error while fetching pay basis list:", error);
    throw error;
  }
}

function getPayBasis(employeeId) {
  try {
    return axiosInstance.get(`/payroll/pay-basis/${employeeId}`);
  } catch (error) {
    console.log("Error while fetching pay basis:", error);
    throw error;
  }
}

function updatePayBasis(employeeId, payBasis) {
  try {
    return axiosInstance.put(`/payroll/pay-basis/${employeeId}`, { pay_basis: payBasis });
  } catch (error) {
    console.log("Error while updating pay basis:", error);
    throw error;
  }
}

export { getPayBasisList, getPayBasis, updatePayBasis };
